import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { lassoForm, Text, TextArea, validator } from '@bd/bdui-forms';
import { Redirect } from '@bd/bdcore-named-routes';
import { css, cx } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';

const styles = css`
  label {
    font-weight: 800;
    font-size: 18px;
    color: #FFFFFF;
    .required {
    }
    @media (max-width: 991px) {
      font-size: 15px;
    }
  }
  .form-row {
    margin: 0 0 30px 0;
    .col {
      padding: 0 30px 0 0;
      @media (max-width: 991px) {
          padding: 0;
      }
    }
    @media (max-width: 991px) {
      margin: 0 0 15px 0;
    }
  }
  input, select, textarea {
    border-radius: 0;
    border-color: #DCD7C7;
    padding: 15px 15px;
    @media (max-width: 991px) {
        padding: 10px;
    }
  }
`;

function validate(values) {
  const response = {
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
  };

  if (!values.firstName) {
    response.firstName = {
      error: 'First Name is required',
    };
  }

  if (!values.lastName) {
    response.lastName = {
      error: 'Last Name is required',
    };
  }

  if (!values.email) {
    response.email = {
      error: 'Email is required',
    };
  } else if (!validator.isEmail(values.email)) {
    response.email = {
      error: 'Email must be valid',
    };
  }

  if (!values.phone) {
    response.phone = {
      error: 'Phone is required',
    };
  }

  return response;
}

class ModalContactForm extends React.Component {
  constructor(props) {
    super(props);

    const { formApi } = props;

    formApi.setValue('formName', this.props.formName);
    formApi.setValue('formLabel', this.props.formLabel);

    this.state = {};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.success && !this.props.success) {
      this.props.onSuccess();
    }
  }

  render() {
    const { className, formApi, success, noRedirect } = this.props;

    function getError(field) {
      return get(formApi, `touched.${field}`) && get(formApi, `errors.${field}`);
    }

    function getErrorClass(field) {
      if (get(formApi, `touched.${field}`) && get(formApi, `errors.${field}`)) {
        return 'ContactForm_invalid is-invalid';
      }

      return null;
    }

    if (success) {
      return (
        <div>
          {
            !noRedirect &&
            <Redirect
              name="contact-us-thank-you"
            />
          }
          {
            noRedirect &&
            <div style={{ color: '#FFFFFF' }}>
              <h4>Thank You</h4>
              <p>
                For contacting us. We have recieved your message and will respond as soon as {' '}
                possible.
              </p>
            </div>
          }
        </div>
      );
    }

    return (
      <div className={cx(styles, className)}>
        <div className="form-row">
          <div className="col">
            <label htmlFor="firstName">First Name <span className="required">*</span></label>
            <Text
              field="firstName"
              name="firstName"
              className={`form-control ${getErrorClass('firstName')}`}
              placeholder="First Name *"
            />
            <div className="invalid-feedback">
              {getError('firstName')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="lastName">Last Name <span className="required">*</span></label>
            <Text
              field="lastName"
              name="lastName"
              className={`form-control ${getErrorClass('lastName')}`}
              placeholder="Last Name *"
            />
            <div className="invalid-feedback">
              {getError('lastName')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="email">Email <span className="required">*</span></label>
            <Text
              field="email"
              name="email"
              className={`form-control ${getErrorClass('email')}`}
              placeholder="Email Address *"
            />
            <div className="invalid-feedback">
              {getError('email')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="phone">Phone <span className="required">*</span></label>
            <Text
              field="phone"
              name="phone"
              className={`form-control ${getErrorClass('phone')}`}
              placeholder="Phone *"
            />
            <div className="invalid-feedback">
              {getError('phone')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="comments">Comments</label>
            <TextArea
              field="comments"
              name="comments"
              className={`form-control ${getErrorClass('comments')}`}
              placeholder="How can our Online Sales Advisors help you?"
              rows="4"
            />
            <div className="invalid-feedback">
              {getError('comments')}
            </div>
          </div>
        </div>
        <button type="submit" className="btn">Send</button>
      </div>
    );
  }
}

ModalContactForm.propTypes = {
  className: PropTypes.string,
  formApi: PropTypes.object.isRequired,
  formLabel: PropTypes.string,
  formName: PropTypes.string,
  success: PropTypes.bool,
  onSuccess: PropTypes.func,
  noRedirect: PropTypes.bool,
};

ModalContactForm.defaultProps = {
  className: undefined,
  formLabel: 'Contact Us Popup',
  formName: 'contactUsModal',
  success: undefined,
  onSuccess: () => {},
  noRedirect: false,
};

export default lassoForm({
  validate,
})(
  withData(
    {
      communities: true,
      areas: true,
    },
  )(ModalContactForm),
);



// WEBPACK FOOTER //
// ./src/components/ModalContactForm.js